<p-selectButton
  [options]="periodOptions"
  [(ngModel)]="calcMethod"
  (onChange)="calcMethodChange.emit($event.value)">
  <ng-template let-item>
    <span class="w-6rem">{{ item.label }}</span>
  </ng-template>
</p-selectButton>
